import axios from 'axios';
import { API_URL } from '../config';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: `${API_URL}`,
  headers: { 'Content-Type': 'application/json' }
});

// Add request interceptor to include JWT token in all requests
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

export const aiModelService = {
  list: async () => {
    const response = await api.get('/ai-models');
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/ai-models/${id}`);
    return response.data;
  },
  
  create: async ({ provider, model_name, api_key }) => {
    const response = await api.post('/ai-models', { provider, model_name, api_key });
    return response.data;
  },
  
  update: async (id, { provider, model_name, api_key, is_active }) => {
    const response = await api.put(`/ai-models/${id}`, { provider, model_name, api_key, is_active });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/ai-models/${id}`);
    return response.data;
  },
  
  testConnection: async (id) => {
    const response = await api.post(`/ai-models/${id}/test`);
    return response.data;
  },
  
  toggleModelStatus: async (id) => {
    const response = await api.put(`/models/${id}/toggle-status`);
    return response.data;
  }
};
